import { render, staticRenderFns } from "./desc.vue?vue&type=template&id=22a4755a&scoped=true"
import script from "./desc.vue?vue&type=script&lang=js"
export * from "./desc.vue?vue&type=script&lang=js"
import style0 from "./desc.vue?vue&type=style&index=0&id=22a4755a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a4755a",
  null
  
)

export default component.exports